import {
  Component, OnInit, Output, EventEmitter, AfterViewInit, Input, OnChanges, SimpleChanges, Inject
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { activation_labels, regex } from '../../utils/constants.helper';
import { MemberService } from '../../services/member.service';
import { environment } from '../../../../environments/environment';
import { LoginService } from '../../services/login.service';
import { UserDetailsModel, UserDetailsV2Model } from '../../models/userdetails.model';

@Component({
  selector: 'app-member-type',
  templateUrl: './member-type.component.html',
  styleUrls: ['./member-type.component.scss'],
})
export class MemberTypeComponent implements OnInit, OnChanges {
  @Output() memberTypeClick = new EventEmitter();

  @Output() SSUSuccess = new EventEmitter();

  @Input() isActiveStep: boolean = false;

  @Input() country?: 'NZ' | 'AU' | null;

  protected readonly labels = activation_labels.memberType;

  memberTypeForm!: FormGroup;

  userDetails!: UserDetailsV2Model | UserDetailsModel;

  popUpsEnabled?: boolean;

  closedManually?: boolean;

  countdown!: number;

  countdownInterval: any;

  private popupCheckInterval: number | null = null;

  private popupWindow: Window | null = null;

  maxDate = new Date();

  minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));

  constructor(
    private memberService: MemberService,
    private loginService: LoginService,
    private snackBar: MatSnackBar,
    @Inject(Window) private window: Window
  ) {}

  ngOnInit(): void {
    this.countdown = 5;
    this.memberTypeForm = new FormGroup({
      firstName: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.NAME_REGEX),
      ]),
      lastName: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.NAME_REGEX),
      ]),
      cardNo: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.CARD_NUMBER_REGEX),
      ]),
      dob: new FormControl(null, [Validators.required]),
    });

    this.loginService.validatedUserDetails.subscribe((details) => {
      if (details) {
        this.userDetails = details;
      }
    });

    this.window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.country !== 'NZ') {
      return;
    }

    if (changes['isActiveStep'] && this.isActiveStep) {
      this.startCountdown();
    } else if (changes['isActiveStep'] && !this.isActiveStep) {
      this.popUpsEnabled = undefined;
      this.closedManually = undefined;
      this.countdown = 5;
      this.countdownInterval = undefined;
      this.popupCheckInterval = null;
      this.popupWindow = null;
    }
  }

  submitExistingMemberDetails(): void {
    this.memberService.saveMemberInputs({
      firstName: this.memberTypeForm.get('firstName')?.value,
      lastName: this.memberTypeForm.get('lastName')?.value,
      cardNo: this.memberTypeForm.get('cardNo')?.value,
      dob: this.memberTypeForm.get('dob')?.value,
    });
    this.memberTypeClick.emit();
  }

  resetExistingMemberDetails(): void {
    this.memberService.saveMemberInputs(null);
  }

  startCountdown(): void {
    this.countdown = 5; // Reset countdown to 5 seconds
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.countdownInterval);
        this.initiateEdrLogin(); // Call the login function when countdown finishes
      }
    }, 1000);
  }

  initiateEdrLogin(): void {
    this.popupWindow = this.window.open(
      environment.edrLoginUrl,
      'EDR Login',
      'width=800,height=600'
    );

    this.popUpsEnabled = !!this.popupWindow;
    if (this.popUpsEnabled) {
      this.closedManually = false;
      this.checkPopupClosed();
    }
  }

  private checkPopupClosed() {
    this.popupCheckInterval = setInterval(() => {
      if (this.popupWindow && this.popupWindow.closed && this.popupCheckInterval) {
        clearInterval(this.popupCheckInterval);
        this.closedManually = true;
      }
    }, 1000);
  }

  private receiveMessage(event: MessageEvent): void {
    if (event.origin !== this.window.location.origin || event.data.from !== 'RedirectionHandler') {
      return;
    }

    clearInterval(this.popupCheckInterval ?? undefined);

    if (this.popupWindow) {
      this.popupWindow.close();
    }

    this.memberService.submitNZMemberActivation(
      {
        employeeId: this.userDetails.employeeId,
        sdcCardNo: this.userDetails.sdcCardNo,
        token: event.data.data['edrstate']
      }
    ).subscribe({
      next: () => {
        this.SSUSuccess.emit();
      },
      error: (error) => {
        this.closedManually = true;
        this.snackBar.open(error || 'An error occurred. Please try again later.', 'Close', {
          duration: 3000,
        });
      }
    });
  }
}
